module.exports = __webpack_public_path__ + "img/thumbnail_Bongo_m_normal.e6a9530f.png";